const headTitleList: any[] = [
  { headTitle: "担当者" },
  { headTitle: "契約者番号" },
  { headTitle: "契約者名" },
  { headTitle: "最終更新日時" },
  { headTitle: "終了" },
];

export { headTitleList };
